module.exports = __webpack_public_path__ + "img/team-19.85a4e5d2.jpg";